import cards from './assets/cards2.json';
import tokens from './assets/tokens.json';
import heroes from './assets/heroes.json';
import newHeroes from './assets/newHeroes.json';
import battlegrounds from './assets/battlegrounds.json';
import cardVersions from './assets/cardVersions.json';
import specials from './assets/specials.json';
import stingers from './assets/nonLegendaryStingers.js';
import triggers from './assets/triggers';

const tokenIDs = tokens.map(a => a.tokenID)
const heroIDs = heroes.map(a => a.id)
const battlegroundsIDs = battlegrounds.map(a => a.cardID)
const duelsIDs = [
  'PVPDR_Hero_Fireheart',
  'PVPDR_Hero_Illucia',
  'PVPDR_Hero_Lilian',
  'PVPDR_Hero_Mozaki',
  'PVPDR_Hero_Omu',
  'PVPDR_Hero_Rattlegore',
  'PVPDR_Hero_Slate',
  'PVPDR_Hero_Stelina',
  'PVPDR_Hero_Turalyon',
  'PVPDR_Hero_Willow',
]

const AVHeroCards = [
  'AV_204',
  'AV_113',
  'AV_200',
  'AV_205',
  'AV_206',
  'AV_207',
  'AV_203',
  'AV_258',
  'AV_316',
  'AV_202'
]

const AVHeroPowers = [
  'AV_113p',
  'AV_200p2',
  'AV_202p',
  'AV_203p',
  'AV_204p',
  'AV_205p',
  'AV_206p',
  'AV_207p',
  'AV_207p2',
  'AV_258p',
  'AV_258p2',
  'AV_258pt',
  'AV_258pt3',
  'AV_258pt4',
  'AV_258pt7',
  'AV_316hp'
]

// TODO - Add default Bob voicelines.
const battlegroundBartenderIDs = [
  //'TB_BaconShopBob',
  'TB_BaconShopBob_SKIN_A',
  'TB_BaconShopBob_SKIN_B',
  'TB_BaconShopBob_SKIN_C',
  'TB_BaconShopBob_SKIN_D'
]

const newHeroSpecials = [...new Set(specials.filter(x => x.soundID != undefined).map(x => x.parentID))]

const cardVersionGroup = (cardID) => {
    const cvg = cardVersions.find(x => x.core == cardID || x.wild == cardID || x.classic == cardID)
    return cvg
}

const nonCoreCardVersions = () => {
  return cardVersions.map(a => a.wild).concat(cardVersions.map(a => a.classic))
}

const battlegroundCard = (cardID) => {

  try {
    const card = battlegrounds.find(x => x.cardID == cardID)
    card.heroSpecific = (card.heroSpecific == 1) // Set this to true or false.
    return card
  } catch (err) {
    return ''
  }
}

const battlegroundTribe = (cardID) => {
  try {
    return battlegrounds.find(x => x.cardID == cardID).tribe
  } catch (TypeError) {
    return ''
  }
}

const battlegroundToken = (cardID) => {
  try {
    return battlegrounds.find(x => x.cardID == cardID).token == 1
  } catch (err) {
    return false
  }
}

const battlegroundTechLevel = (card) => {
  if (card.id == 'GVG_058') return 2
  else if (card.id == 'TB_BaconShop_HP_033t') return 1
  else return card.techLevel
}

const battlegroundHeroSpecific = (cardID) => {
  try {
    return battlegrounds.find(x => x.cardID == cardID).heroSpecific == 1
  } catch (err) {
    return false
  }
}

const battlegroundFlavor = (cardID) => {
  try {
    return battlegrounds.find(x => x.cardID == cardID).flavor
  } catch (err) {
    return ''
  }
}

const battlegroundRetired = (cardID) => {
  try {
    return battlegrounds.find(x => x.cardID == cardID).retired
  } catch (err) {
    return false
  }
}

const sortCards = (cards, type) => {
  function classOrder(a) {
    // Dual Class Cards
    switch(a.cardClass) {
      case 'DEATHKNIGHT': return 0
      case 'DEMONHUNTER': return 1
      case 'DRUID': return 2
      case 'HUNTER': return 3
      case 'MAGE': return 4
      case 'PALADIN': return 5
      case 'PRIEST': return 6
      case 'ROGUE': return 7
      case 'SHAMAN': return 8
      case 'WARLOCK': return 9
      case 'WARRIOR': return 10
      default: return 99
    }
  }

  function tribeOrder(a) {
    switch(battlegroundTribe(a.id)) {
      case 'Beast': return 1
      case 'Demon': return 2
      case 'Dragon': return 3
      case 'Mech': return 4
      case 'Murloc': return 5
      case 'Pirate': return 6
      case 'Elemental': return 7
      case 'Neutral': return 8
      default: return 99
    }
  }

  if(type == 'general' || type == 'heroes') {
    return cards.sort(
      function(a,b) {
        var classA = classOrder(a)
        var classB = classOrder(b)

        if(classA < classB )  { return -1}
        if(classA > classB )  { return 1}
        if(classA == classB ) {
          if(a.name < b.name )    {return -1}
          if(a.name > b.name )   {return 1}
          if(a.name == b.name )  {return 0}
        }
      }
    )
  } else if (type == 'battlegrounds') {
    return cards.sort (
      function(a,b) {
          var tribeA = tribeOrder(a)
          var tribeB = tribeOrder(b)
          var techLevelA = battlegroundTechLevel(a)
          var techLevelB = battlegroundTechLevel(b)

          if(techLevelA == undefined) {return -1}
          if(techLevelA < techLevelB) {return -1}
          if(techLevelA > techLevelB) {return 1}
          if(techLevelA== techLevelB) {
            if(tribeA < tribeB )  { return -1}
            if(tribeA > tribeB )  { return 1}
            if(tribeA == tribeB ) {
              if(a.name < b.name )   {return -1}
              if(a.name > b.name )   {return 1}
              if(a.name == b.name )  {return 0}
            }
          }
        }
    )
  } else {
    return cards
  }
}

const generalCards = sortCards(cards.filter(x => (!heroIDs.includes(x.id))), 'general')
const heroCards = sortCards(cards.filter(x => heroIDs.includes(x.id)), 'heroes')
const bgCards = sortCards(cards.filter(x => (battlegroundsIDs.includes(x.id)) || battlegroundBartenderIDs.includes(x.id)), 'battlegrounds')
const duelsCards = sortCards(cards.filter(x => (duelsIDs.includes(x.id))), 'duels')

const defaultGamePlaySounds = [
  ['Opening','S1'],
  ['Opening (Mirror)','S2'],
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
  ['Chosen in Arena','PA']
]

const defaultEmoteSounds = [
  ['Thanks','EM_TH1'],
  ['Greetings', 'EM_G1'],
  ['Greetings (Mirror)', 'EM_G2'],
  ['Wow','EM_W'],
  ['Threaten','EM_T'],
  ['Well Played','EM_WP'],
  ['Oops','EM_O'],
  ['Sorry','EM_S1']
]

const defaultErrorSounds = [
  ['Need Weapon', 'E1'],
  ['Mana', 'E2'],
  ['Minion Attacked', 'E3'],
  ['Hero Attacked', 'E4'],
  ['Summon Sickness', 'E5'],
  ['Full Hand', 'E6'],
  ['Too Many Minions', 'E7'],
  ['Stealth Minion', 'E8'],
  ['Can\'t Play', 'E9'],
  ['Invalid Target', 'E10'],
  ['Taunt Minion', 'E11'],
  ['Generic', 'E12'],
]

const defaultHolidaySounds = [
  ['New Year','H_NY'],
  ['Lunar New Year','H_LNY'],
  ['Noble\nGarden','H_NG'],
  ['Mid\nSummer','H_MS'],
  ['Pirate Day','H_PD'],
  ['Hallow\'s End','H_HE'],
  ['Winter Veil','H_WV'],
]

const defaultHeroSounds = [
  ['Gameplay', defaultGamePlaySounds],
  ['Emotes', defaultEmoteSounds],
  ['Errors', defaultErrorSounds],
  ['Holidays', defaultHolidaySounds]
]

const deathKnightGamePlaySounds = [
  ['Intro (1)','I1'],
  ['Intro (2)','I2'],
  ['Summon','S1'],
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
]
const deathKnightEmoteSounds = [
  ['Thanks','EM_TH1'],
  ['Greetings', 'EM_G1'],
  ['Wow','EM_W'],
  ['Threaten','EM_T'],
  ['Well Played','EM_WP'],
  ['Oops','EM_O']
]
const deathKnightHeroSounds = [
  ['Gameplay', deathKnightGamePlaySounds],
  ['Emotes', deathKnightEmoteSounds]
]



const deathKnightRexxarGameplaySounds = arraySplicer(deathKnightGamePlaySounds, [[3,0,['Summon (Mirror)', 'S2']]])
const deathKnightRexxarEmoteSounds = arraySplicer(deathKnightEmoteSounds, [[2,0,['Greetings (Mirror)', 'EM_G2']]])
const deathKnightRexxarHeroSounds = [
  ['Gameplay', deathKnightRexxarGameplaySounds],
  ['Emotes', deathKnightRexxarEmoteSounds]
]

const sharedCustomGamePlaySounds = [
  ['Intro','I1'],
  ['Summon','S1'],
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
]
const sharedCustomEmoteSounds = [
  ['Thanks','EM_TH1'],
  ['Greetings', 'EM_G1'],
  ['Wow','EM_W'],
  ['Threaten','EM_T'],
  ['Well Played','EM_WP'],
  ['Oops','EM_O']
]
const sharedCustomHeroSounds = [
  ['Gameplay', sharedCustomGamePlaySounds],
  ['Emotes', sharedCustomEmoteSounds]
]

const heroCardCustomGamePlaySounds = [
  ['Intro', 'S'],
  ['Play','P'],
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
]

const heroCardCustomEmoteSounds = [
  ['Thanks','EM_TH1'],
  ['Greetings', 'EM_G1'],
  ['Greetings (Mirror)', 'EM_G2'],
  ['Wow','EM_W'],
  ['Threaten','EM_T'],
  ['Well Played','EM_WP'],
  ['Oops','EM_O']
]

const heroCardCustomSounds = [
  ['Gameplay', heroCardCustomGamePlaySounds],
  ['Emotes', heroCardCustomEmoteSounds],
]

const galakrondGamePlaySounds = [
  ['Intro','I1'],
  ['Summon','P'],
  ['Opening','S1'],
  ['Opening (Mirror)','S2'],
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
]
const galakrondHeroSounds = [
  ['Gameplay', galakrondGamePlaySounds],
  ['Emotes', defaultEmoteSounds],
  ['Errors', defaultErrorSounds],
  ['Holidays', defaultHolidaySounds]
]

const ragAndLordJarraxxusGamePlaySounds = [
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
]
const ragAndLordJarraxxusHeroSounds = [
  ['Gameplay', ragAndLordJarraxxusGamePlaySounds],
  ['Emotes', defaultEmoteSounds],
  ['Errors', defaultErrorSounds],
  ['Holidays', defaultHolidaySounds]
]

const medivhHolidaySounds = [
  ['New Year','H_NY'],
  ['Lunar New Year','H_LNY'],
  ['Noble\nGarden','H_NG'],
  ['Hallow\'s End','H_HE'],
  ['Winter Veil','H_WV'],
]
const medivhHeroSounds = [
  ['Gameplay', defaultGamePlaySounds],
  ['Emotes', defaultEmoteSounds],
  ['Errors', defaultErrorSounds],
  ['Holidays', medivhHolidaySounds]
]

const renoGamePlaySounds = [
  ['Intro','I1'],
  ['Summon','S1'],
  ['Attack','A1'],
  ['Concede','C'],
  ['Death','D'],
  ['Out of Time','T'],
  ['Thinking (1)','T1'],
  ['Thinking (2)','T2'],
  ['Thinking (3)','T3'],
  ['Low on Cards','LC'],
  ['Out of Cards','NC'],
  ['Chosen in Arena','PA']
]
const renoHeroSounds = [
  ['Gameplay', renoGamePlaySounds],
  ['Emotes', defaultEmoteSounds]
]

const bartenderGeneralSounds = [
  ['Selected', 'BG_S'],
  ['New Game (1)','BG_NG1'],
  ['New Game (2)','BG_NG2'],
  ['New Game (3)','BG_NG3']
]

const bartenderShopSounds = [
  ['General (1)', 'BG_G1'],
  ['General (2)', 'BG_G2'],
  ['General (3)', 'BG_G3'],
  ['Flavor (1)','BG_F1'],
  ['Flavor (2)','BG_F2'],
  ['Flavor (3)','BG_F3'],
  ['Flavor (4)','BG_F4'],
  ['Flavor (5)','BG_F5'],
  ['Flavor (6)','BG_F6'],
  ['Flavor (7)','BG_F7'],
  ['Flavor (8)','BG_F8'],
  ['Idle (1)','BG_I1'],
  ['Idle (2)','BG_I2'],
  ['Idle (3)','BG_I3'],
  ['Idle (4)','BG_I4'],
  ['Idle (5)','BG_I5'],
  ['Upgrade (1)','BG_SU1'],
  ['Upgrade (2)','BG_SU2'],
  ['Upgrade (3)','BG_SU3'],
  ['Upgrade (4)','BG_SU4']
]

const bartenderRecruitSounds = [
  ['Hire (1)','BG_H1'],
  ['Hire (2)','BG_H2'],
  ['Recruit Small (1)','BG_RS1'],
  ['Recruit Small (2)','BG_RS2'],
  ['Recruit Small (3)','BG_RS3'],
  ['Recruit Med (1)','BG_RM1'],
  ['Recruit Med (2)','BG_RM2'],
  ['Recruit Med (3)','BG_RM3'],
  ['Recruit Large (1)','BG_RL1'],
  ['Recruit Large (2)','BG_RL2'],
  ['Recruit Large (3)','BG_RL3'],
  ['Freezing (1)','BG_FR1'],
  ['Freezing (2)','BG_FR2'],
  ['Selling (1)','BG_SE1'],
  ['Selling (2)','BG_SE2'],
  ['Triple (1)','BG_T1'],
  ['Triple (2)','BG_T2'],
  ['Triple (3)','BG_T3'],
  ['After Triple (1)','BG_AT1'],
  ['After Triple (2)','BG_AT2'],
  ['After Triple (3)','BG_AT3']
]

const bartenderCombatSounds = [
  ['Combat Start (1)','BG_CS1'],
  ['Combat Start (2)','BG_CS2'],
  ['Ahead (1)','BG_A1'],
  ['Ahead (2)','BG_A2'],
  ['Ahead (3)','BG_A3'],
  ['Behind (1)','BG_B1'],
  ['Behind (2)','BG_B2'],
  ['Behind (3)','BG_B3'],
  ['Loss (1)','BG_L1'],
  ['Loss (2)','BG_L2'],
  ['Loss (3)','BG_L3'],
  ['Win (1)','BG_W1'],
  ['Win (2)','BG_W2'],
  ['Win (3)','BG_WI3'],
  ['First Place (1)','BG_FP1'],
  ['First Place (2)','BG_FP2'],
  ['First Place (3)','BG_FP3']
]

const bartenderSounds = [
  ['Start', bartenderGeneralSounds],
  ['Shop', bartenderShopSounds],
  ['Recruit', bartenderRecruitSounds],
  ['Combat', bartenderCombatSounds]
]

const venariCombatSounds = [
  ['Combat Start (1)','BG_CS1'],
  ['Combat Start (2)','BG_CS2'],
  ['Ahead (1)','BG_A1'],
  ['Ahead (2)','BG_A2'],
  ['Ahead (3)','BG_A3'],
  ['Behind (1)','BG_B1'],
  ['Behind (2)','BG_B2'],
  ['Behind (3)','BG_B3'],
  ['Loss (1)','BG_L1'],
  ['Loss (2)','BG_L2'],
  ['Loss (3)','BG_L3'],
  ['Loss (4)','BG_L4'],
  ['Win (1)','BG_W1'],
  ['Win (2)','BG_W2'],
  ['Win (3)','BG_WI3'],
  ['First Place (1)','BG_FP1'],
  ['First Place (2)','BG_FP2'],
  ['First Place (3)','BG_FP3']
]

const customVenari = [
  ['Start', bartenderGeneralSounds],
  ['Shop', bartenderShopSounds],
  ['Recruit', bartenderRecruitSounds],
  ['Combat', venariCombatSounds]
]

const customCthun = [
  ['Whisper (1)', 'SP1'],
  ['Whisper (2)', 'SP2'],
  ['Whisper (3)', 'SP3'],
  ['Whisper (4)', 'SP4'],
  ['Whisper (5)', 'SP5'],
  ['Whisper (6)', 'SP6'],
  ['Whisper (7)', 'SP7'],
  ['Whisper (8)', 'SP8'],
  ['Whisper (9)', 'SP9'],
  ['Whisper (10)', 'SP10'],
  ['Whisper (11)', 'SP11'],
  ['Whisper (11)', 'SP12']
]

const customAluneth = [
  ['Play (1)', 'SP1'],
  ['Play (2)', 'SP2'],
  ['Play (3)', 'SP3'],
  ['Trigger (1)', 'SP5'],
  ['Trigger (2)', 'SP5'],
  ['Trigger (3)', 'SP6'],
  ['Trigger (4)', 'SP7'],
  ['Trigger (5)', 'SP8'],
  ['Trigger (6)', 'SP9'],
  ['Death (1)', 'SP10'],
  ['Death (2)', 'SP11'],
  ['Death (3)', 'SP12']
]

const customSkulloftheManari = [
  ['Play (1)', 'SP1'],
  ['Play (2)', 'SP2'],
  ['Play (3)', 'SP3'],
  ['Trigger (1)', 'SP4'],
  ['Trigger (2)', 'SP5'],
  ['Trigger (3)', 'SP6'],
  ['Death (1)', 'SP7'],
  ['Death (2)', 'SP8'],
]

const customBarnes = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2'],
  ['Play (3)', 'P3'],
  ['Play (4)', 'P4'],
  ['Play (5)', 'P5'],
  ['Play (6)', 'P6']
]

const customHecklebot = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2'],
  ['Play (3)', 'P3'],
  ['Play (4)', 'P4'],
  ['Play (5)', 'P5'],
  ['Play (6)', 'P6'],
  ['Play (7)', 'P7'],
  ['Play (8)', 'P8'],
  ['Attack (9)', 'A9'],
  ['Attack (1)', 'A1'],
  ['Attack (2)', 'A2'],
  ['Attack (3)', 'A3'],
  ['Attack (4)', 'A4'],
  ['Attack (5)', 'A5'],
  ['Attack (6)', 'A6'],
  ['Attack (7)', 'A7'],
  ['Attack (8)', 'A8'],
  ['Attack (9)', 'A9']
]

const customVulgarHomunculus = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2'],
  ['Play (3)', 'P3'],
  ['Play (4)', 'P4'],
  ['Attack (9)', 'A9'],
  ['Attack (1)', 'A1'],
  ['Attack (2)', 'A2'],
  ['Attack (3)', 'A3'],
  ['Attack (4)', 'A4']
]

const customEvilHeclkerDalaranCrusader = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2']
]

const customYogg = [
  ['Spin (1)', 'SP1'],
  ['Spin (2)', 'SP2'],
  ['Spin (3)', 'SP3'],
  ['Spin (4)', 'SP4'],
  ['Spin (5)', 'SP5'],
  ['Spin (6)', 'SP6'],
]

const customFortuneTeller = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2'],
  ['Play (3)', 'P3'],
  ['Play (4)', 'P4'],
  ['Play (5)', 'P5'],
  ['Play (6)', 'P6']
]

const customCheesemonger = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2'],
  ['Play (3)', 'P3'],
  ['Play (4)', 'P4'],
  ['Play (5)', 'P5'],
  ['Play (6)', 'P6']
]

const customElitistSnob = [
  ['Play (1)', 'P1'],
  ['Play (2)', 'P2'],
  ['Play (3)', 'P3'],
  ['Play (4)', 'P4'],
  ['Play (5)', 'P5']
]

function customHipster(cardID) {
  let customHipsterPlayArray = []
  let customHipsterSounds = getCardSounds(cards.find(card => card.id == cardID), false).find(sounds => (sounds.name == "Play" && sounds.random)).audio

  for (let i = 0; i < customHipsterSounds.length; i++) { 
    customHipsterPlayArray.push(['Play' + ' (' + (i + 1) + ')', customHipsterSounds[i]])
  }

  return customHipsterPlayArray
}

const transferStudentTokens = cards.filter(card => card['id'].includes('SCH_199t') && card['type'] == 'MINION')
  .sort((a,b) => a['id'].replace('SCH_199t', '') - b['id'].replace('SCH_199t', ''))
  .map(card => card['id'])

function arraySplicer(startArray, splices) {
  var newArray = startArray.slice(0)
  var x
  for (x of splices) {
    newArray.splice(x[0],x[1],x[2])
  }
  return newArray
}

function complicatedAltSound(cardID, soundID = '') {
  var standardAltSoundArray = ['A1','EM_G1','EM_G2','S2','EM_O','PA','S1','EM_TH1','EM_T','EM_WP','EM_W']

  // if (newHeroes[cardID]) {
  //   if (
  //       (newHeroes[cardID].altSounds == 'standardAlt' && !standardAltSoundArray.includes(soundID)) || // Case one, standard array.
  //       (newHeroes[cardID].altSounds == 'all') || // Case two, replace for all sounds.
  //       (!newHeroes[cardID].altSounds.includes(soundID)) // Case three, replace for sounds in specific array.
  //   ) {
  //     return newHeroes[cardID].parent
  //   }
  // }
  

  // WARRIOR
  // Corrupt Garrosh
  if (['HERO_01b'].includes(cardID)) return 'HERO_01'
  // Nagrand Garrosh, Lu Bao Garrosh, Garrosh of Might, Garrosh of Wrath, Pirate King Garrosh, Forge-wrought Garrosh, Garrosh the Wild
  else if (["HERO_01d","HERO_01g",'HERO_01f','HERO_01h','HERO_01n','HERO_01p','HERO_01s'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_01'
  // Rokara
  else if (['HERO_01i','HERO_01j','HERO_01k','HERO_01m'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_01l'
  // Magni
  else if (['HERO_01q'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_01a'
  // SHAMAN
  // Warchief Thrall
  else if (['HERO_02d'].includes(cardID)) return 'HERO_02'
  // Earthfury Thrall, Thrall Son of Durotan, Alterac Thrall, Wolfrider Thrall, Frostwolf Thrall, Ten Storm Thrall, Frog Prince Thrall, Mechaconduit Thrall, Snowman Thrall, Jade Serpent Thrall
  else if (['HERO_02f','HERO_02g','HERO_02h','HERO_02i','HERO_02j','HERO_02k','HERO_02n','HERO_02o','HERO_02t','HERO_02u'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_02'
  // Bru'kan
  else if (['HERO_02p','HERO_02q','HERO_02r'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_02s'
  //ROGUE
  // Cap'n Valeera
  else if (['HERO_03b'].includes(cardID)) return 'HERO_03'
  // Nightslayer Valeera, Gladiator Valeera, Deathmantle Valeera, Titanblade Valeera, Valeera the Nice, Garden Party Valeera
  else if (['HERO_03d','HERO_03f','HERO_03g','HERO_03n', 'HERO_03o', 'HERO_03q'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_03'
  // Chef Scabbs, Agent Scabbs, Investigator Scabbs -> Undercover Scabbs for some voicelines.
  else if (['HERO_03i','HERO_03j','HERO_03k'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_03l'
  // PALADIN
  // Lightforged Uther
  else if (['HERO_04d'].includes(cardID)) return 'HERO_04'
  // Second War Uther, Horseman Uther, Uther Lawbringer, Guan Yu Uther, Judgement Uther, Righteous Infero Uther, Ascended Uther, Star Ascendant Uther, Greench Uther
  else if (['HERO_04e','HERO_04f','HERO_04g','HERO_04h','HERO_04i','HERO_04k','HERO_04m','HERO_04n','HERO_04s'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_04'
  // Cariel
  else if (['HERO_04o','HERO_04p','HERO_04q'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_04r'
  // HUNTER
  // Wanderer Rexxar
  else if (['HERO_05b'].includes(cardID)) return 'HERO_05'
  // Warsong Rexxar (Weird Set)
  else if (['HERO_05d'].includes(cardID) && !(['A1','EM_G1','S2','EM_O','PA','S1','EM_TH1','T3','EM_T','EM_WP','SP1'].includes(soundID))) return 'HERO_05'
  // Giantstalker Rexxar, Firefang Rexxar, Dragonstalker Rexxar, Flamewalker Rexxar, Robin Hood Rexxar, 'Iron Hunter Rexxar', Snowflipper Rexxar, Black Ox Rexxar, Denwatcher Rexxar
  else if (['HERO_05e','HERO_05g','HERO_05f','HERO_05j','HERO_05o','HERO_05p','HERO_05r','HERO_05t'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_05'
  // DRUID
  // Shan'do Malfurion
  else if (['HERO_06c'].includes(cardID)) return 'HERO_06'
  // Cenarion Malfurion, Storm's Rage Malfurion, Emerald Malfurion, Druid of the Flame Malfurion, Winter Fury Malfurion, Steel Guardian Malfurion, Ice Lord Malfurion
  else if (['HERO_06e','HERO_06g','HERO_06i','HERO_06j','HERO_06o','HERO_06p','HERO_06q'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_06'
  // Guff Runetotem, Spelunker Guff, Fangbound Guff, Fauna Friend Guff
  else if (['HERO_06k','HERO_06l','HERO_06m'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_06n'
  // Cherry Blossom Lunara
  else if (['HERO_06t'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_06a'    
  // WARLOCK
  // Shadow Gul'dan
  else if (['HERO_07c'].includes(cardID)) return 'HERO_07'
  // Felheart Gul'dan, Nemesis Gul'dan, Shadowmoon Gul'Dan, House of Rituals Gul'dan, Fel Colossus Gul'dan, Hatcher Gul'dan
   else if (['HERO_07e','HERO_07f','HERO_07g','HERO_07m','HERO_07n','HERO_07r'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_07'
  // Scholomance Tamsin, Impressive Tasmin, Summoner Tamsin -> Tamsin Triumphant
   else if (['HERO_07i','HERO_07j','HERO_07k'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_07l'
  // Nemsy
  else if (['HERO_07o'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_07a'    
  // MAGE
  // Fire Mage Jaina
  else if (['HERO_08c'].includes(cardID)) return 'HERO_08'
  // Scholar Jaina, Arcanist Jaina, Apprentice Jaina, Archmage Jaina, Kul Tiran Jaina, Netherwind Jaina, Red Riding Hood Jaina, Arcane Sentinel Jaina, Frost Fairy Jaina, Red Crane Jaina, Festival Jaina
  else if (['HERO_08f','HERO_08g','HERO_08h','HERO_08i','HERO_08j','HERO_08k','HERO_08n','HERO_08o','HERO_08t','HERO_08u','HERO_08w'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_08'
  // Varden
  else if (['HERO_08p','HERO_08q','HERO_08r'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_08s'
  // PRIEST
  // King Anduin
  else if (['HERO_09c'].includes(cardID)) return 'HERO_09'
  // Anduin of Prophecy, SI:7 Anduin, Zhuge Liang Anduin, Transcendence Anduin, Prince Charming Anduin, Holy Leviathan Anduin, Little Lion Anduin
  else if (['HERO_09d', 'HERO_09e', 'HERO_09f','HERO_09g','HERO_09m','HERO_09n','HERO_09q'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_09'
  // Xyrella
  else if (['HERO_09h','HERO_09i','HERO_09j','HERO_09l'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_09k'
  // Tyrande
  else if (['HERO_09o'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_09a'
  // DEMONHUNTER
  else if (['HERO_10a'].includes(cardID)) return 'HERO_10'
  // Demonbane Illidan, Felravager Illidan, Skullbearer Illidan, Ember Court Illidan, Infernal Armor Illidan, Illidan the Naughty, Sha Illidan, Sabertender Illidan
  else if (['HERO_10c','HERO_10d','HERO_10h','HERO_10k', 'HERO_10l','HERO_10m','HERO_10n','HERO_10p'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_10'
  // Kurtrus
  else if (['HERO_10e','HERO_10f','HERO_10g','HERO_10j'].includes(cardID) && !(standardAltSoundArray.includes(soundID))) return 'HERO_10i'
  // Lord Jaraxxus
  else if (['CORE_EX1_323'].includes(cardID)) return 'EX1_323h'
  // Death Knights
  else if (['CORE_ICC_827'].includes(cardID)) return 'ICC_827'
  else if (['CORE_ICC_829'].includes(cardID)) return 'ICC_829'
  else if (['CORE_ICC_481'].includes(cardID)) return 'ICC_481'
  else if (['CORE_ICC_830'].includes(cardID)) return 'ICC_830'
  else if (['CORE_ICC_834'].includes(cardID)) return 'ICC_834'
  else if (['CORE_ICC_832'].includes(cardID)) return 'ICC_832'
  else if (['CORE_ICC_833'].includes(cardID)) return 'ICC_833'
  else if (['CORE_ICC_828'].includes(cardID)) return 'ICC_828'
  else if (['CORE_ICC_831'].includes(cardID)) return 'ICC_831'

  else return cardID
}

function altSoundsID(cardID) {

  if (['BAR_024','BAR_031','BAR_034t3','BAR_034t5','BAR_533t','BAR_538','BAR_745','CS3_037','SW_072',
        'SW_075','SW_031t8','SW_097','SW_429t','SW_443t','SW_463t','DED_517t','DED_514','AV_113t3t2','AV_215',
        'AV_218t','AV_294','AV_337', 'ONY_001t', 'ONY_012t','TSC_029t2','TSC_219t2','TSC_219t3','TSC_219t4',
        'TSC_610','TSC_638t3','TSC_638t4','TSC_659','TSC_919','TSC_919t','TSC_932t','TSC_937t3',
        'TID_700','TID_711t2','TID_711t3','TID_711t4','TID_711t5','TID_711t6','TID_712t','TID_712t2','TID_744'
      ].includes(cardID) || cardVersionGroup(cardID) != undefined) 
  {
    if (cardID == 'BAR_024') return 'ULD_190'
    if (cardID == 'BAR_031') return 'UNG_076t1'
    if (cardID == 'BAR_034t3') return 'NEW1_017'
    if (cardID == 'BAR_034t4') return 'OG_064a'
    if (cardID == 'BAR_034t5') return 'CFM_335'
    if (cardID == 'BAR_533t') return 'TRL_546'
    if (cardID == 'BAR_538') return 'TRL_309t'
    if (cardID == 'BAR_745') return 'ULD_154t'
    if (cardID == 'CS3_037') return 'UNG_801'
    if (cardID == 'SW_072') return 'UNG_086'
    if (cardID == 'SW_075') return 'OG_326'
    if (cardID == 'SW_031t8') return 'LOE_016'
    if (cardID == 'SW_097') return 'EX1_556'
    if (cardID == 'SW_429t') return 'TRL_546'
    if (cardID == 'SW_443t') return 'CFM_343'
    if (cardID == 'SW_463t') return 'KAR_030'
    if (cardID == 'DED_517t') return 'EX1_089'
    if (cardID == 'DED_514') return 'GIL_838'
    if (cardID == 'AV_113t3t2') return 'EX1_554t'
    if (cardID == 'AV_215') return 'DRG_065'
    if (cardID == 'AV_218t') return 'CS2_tk1'
    if (cardID == 'AV_294') return 'BGS_021'
    if (cardID == 'AV_337') return 'TRL_550'
    if (cardID == 'ONY_001t') return 'GIL_190t'
    if (cardID == 'ONY_012t') return 'TRLA_127'
    if (cardID == 'TSC_029t2') return 'TSC_029t'
    if (['TSC_219t2','TSC_219t3','TSC_219t4'].includes(cardID)) return 'TSC_219t'
    if (cardID == 'TSC_610') return 'SW_434'
    if (cardID == 'TSC_638t3') return 'TSC_638t2'
    if (cardID == 'TSC_638t4') return 'TSC_638'
    if (cardID == 'TSC_659') return 'BT_133'
    if (['TSC_919','TSC_919t'].includes(cardID)) return 'EX1_089'
    if (cardID == 'TSC_932t') return 'ULD_292'
    if (cardID == 'TSC_937t3') return 'TSC_937t'
    if (cardID == ('TID_700')) return 'ULD_292'
    if (['TID_711t2','TID_711t3','TID_711t4','TID_711t5','TID_711t6'].includes(cardID)) return 'TID_711t'
    if (['TID_712t','TID_712t2'].includes(cardID)) return 'TSC_219t'
    if (cardID == 'TID_744') return 'TSC_003'

    // Cards with version groups will always be mapped to the wild (oldest) version's sounds.
    else if (cardVersionGroup(cardID) != undefined) return cardVersionGroup(cardID).wild
    else return cardID

  } else return cardID

}

function getCardSounds (card, excludeRandom = true) {
  // This handles the multi sound case.
  let cardSounds = card.sounds

  // Handle cards without a sound array defined (this is for most pre-Return to Naxx cards)
  if ((cardSounds == undefined || cardSounds.length == 0) && card.type == 'MINION') {
    cardSounds = [
      {
        "name": "Play",
        "audio": altSoundsID(card.id) + "_P"
      },
      {
        "name": "Attack",
        "audio": altSoundsID(card.id) + "_A"
      },
      {
        "name": "Death",
        "audio": altSoundsID(card.id) + "_D"
      },
    ]

    if (stingers.includes(card.id) || card.rarity == 'LEGENDARY') {
      cardSounds.push(
        {
          "name": "MusicStinger",
          "audio": altSoundsID(card.id) + "_S"
        })
    }

    if (triggers.includes(card.id)) {
      cardSounds.push(
        {
          "name": "Trigger",
          "audio": altSoundsID(card.id) + "_TR"
        })
    }  
  } else {
    cardSounds = cardSounds.map(sound => sound.multi != undefined ? sound.multi : sound).flat()
  }

  // By storing valid sounds in this structure, each dictionary will create a row of sounds.
  const validSounds = [
    {'value': 'Stinger', 'name': 'Intro', 'row': 1}, 
    {'value': 'Trigger','name': 'Trigger', 'row': 1}, 
    {'value': 'Play', 'name': 'Play', 'row': 2}, 
    {'value': 'Attack', 'name': 'Attack', 'row': 2}, 
    {'value': 'Death', 'name': 'Death', 'row': 2}
  ]    

  // Exclude underlays for now.
  cardSounds = cardSounds.filter(sound => !(sound.name.includes('Underlay')) && !(sound.name == 'Special'))

  // Exclude random if needed.
  if (excludeRandom) {
    cardSounds = cardSounds.filter(sound => !sound.random)
  }

  // Determine sound rows.
  for (let i = 0; i < cardSounds.length; i++) {
    const matchedValidSound = validSounds.find(row => cardSounds[i].name.includes(row.value))
    if (matchedValidSound) {
      cardSounds[i].row = matchedValidSound.row
      cardSounds[i].name = matchedValidSound.name
    }
  }    

  return cardSounds
}

function buildHeroSoundArray(card) {

  let cardSounds = card.sounds.filter(sound => sound["name"] != 'Special')

  // Handle multi case, specifically for hero cards.
  cardSounds = cardSounds.map(sound => sound.multi != undefined ? sound.multi : sound).flat()

  let soundSections = [
    'Gameplay',
    'Emotes',
    'Errors',
    'Holidays'
  ]

  let heroSoundDicts = [
    // Gameplay
    {'name': 'Play', 'section': 'Gameplay', 'order': -1},
    {'name': 'Opening', 'section': 'Gameplay', 'order': 0},
    {'name': 'Mirror Start', 'section': 'Gameplay', 'buttonName': 'Opening (Mirror)', 'order': 1},
    {'name': 'Attack', 'section': 'Gameplay', 'order': 2},
    {'name': 'Concede', 'section': 'Gameplay', 'order': 3},
    {'name': 'Death', 'section': 'Gameplay', 'order': 4},
    {'name': 'Out of Time', 'section': 'Gameplay', 'order': 5},
    {'name': 'Thinking (1)', 'section': 'Gameplay', 'order': 6},
    {'name': 'Thinking (2)', 'section': 'Gameplay', 'order': 7},
    {'name': 'Thinking (3)', 'section': 'Gameplay', 'order': 8},
    {'name': 'Low on Cards', 'section': 'Gameplay', 'order': 9},
    {'name': 'Out of Cards', 'section': 'Gameplay', 'order': 10},
    {'name': 'Picked in Arena', 'section': 'Gameplay', 'order': 11},
    
    // Emotes
    {'name': 'Thanks', 'section': 'Emotes', 'order': 1},
    {'name': 'Greetings', 'section': 'Emotes', 'order': 2},
    {'name': 'Greetings (Mirror)', 'section': 'Emotes', 'order': 3},
    {'name': 'Wow', 'section': 'Emotes', 'order': 4},
    {'name': 'Threaten', 'section': 'Emotes', 'order': 5},
    {'name': 'Well Played', 'section': 'Emotes', 'order': 6},
    {'name': 'Oops', 'section': 'Emotes', 'order': 7},
    {'name': 'Sorry', 'section': 'Emotes', 'order': 8},
    
    // Errors
    {'name': 'Need Weapon', 'section': 'Errors', 'order': 1},
    {'name': 'Mana', 'section': 'Errors', 'order': 2},
    {'name': 'Minion Attacked', 'section': 'Errors', 'order': 3},
    {'name': 'Hero Attacked', 'section': 'Errors', 'order': 4},
    {'name': 'Summon Sickness', 'section': 'Errors', 'order': 5},
    {'name': 'Full Hand', 'section': 'Errors', 'order': 6},
    {'name': 'Too Many Minions', 'section': 'Errors', 'order': 7},
    {'name': 'Stealth Minion', 'section': 'Errors', 'order': 8},
    {'name': 'Can\'t Play', 'section': 'Errors', 'order': 9},
    {'name': 'Invalid Target', 'section': 'Errors', 'order': 10},
    {'name': 'Taunt Minion', 'section': 'Errors', 'order': 11},
    {'name': 'Generic', 'section': 'Errors', 'order': 12},

    //Holidays
    {'name': 'New Year', 'section': 'Holidays', 'order': 1},
    {'name': 'Lunar New Year', 'section': 'Holidays', 'order': 2},
    {'name': 'Noblegarden', 'section': 'Holidays', 'buttonName': 'Noble Garden', 'order': 3},
    {'name': 'Mid Summer', 'section': 'Holidays', 'order': 4},
    {'name': 'Pirate Day', 'section': 'Holidays', 'buttonName': 'Pirate\'s Day', 'order': 5},
    {'name': 'Hallow\'s End', 'section': 'Holidays', 'order': 6},
    {'name': 'Winter Veil', 'section': 'Holidays', 'order': 7},
  ]

  let heroSounds = cardSounds.filter(sound => heroSoundDicts.map(x => x['name']).includes(sound['name']))

  heroSounds = heroSounds.map(sound => {
    let heroSoundDict = heroSoundDicts.find(x => x['name'] == sound['name'])
    sound['buttonName'] = heroSoundDict['buttonName'] != undefined ? heroSoundDict['buttonName'] : sound['name']

    if (sound['name'] == 'Play' && sound['audio'].includes('Stinger')) {
      sound['buttonName'] = 'Intro'
    }

    sound['order'] = heroSoundDict['order']
    sound['section'] = heroSoundDict['section']
    return sound
  })

  let soundArray = soundSections.filter(section => heroSounds.filter(sound => sound['section'] == section).length != 0).map(section => {
    return {'title': section, 'sounds': heroSounds.filter(sound => sound['section'] == section).sort((a,b) => a['order'] - b['order'])}
  })    

  let soundsNotMapped = cardSounds.filter(sound => !heroSoundDicts.map(x => x['name']).includes(sound['name']))
  
  if (soundsNotMapped.length != 0)
    console.log(soundsNotMapped)

  return soundArray
}

export {tokenIDs, heroIDs, AVHeroCards, AVHeroPowers, battlegroundsIDs, duelsIDs, cardVersionGroup, newHeroSpecials,
  battlegroundTribe, battlegroundToken, battlegroundHeroSpecific, battlegroundFlavor, battlegroundRetired, battlegroundTechLevel, battlegroundCard, battlegroundBartenderIDs, bartenderSounds, customVenari,
  generalCards, heroCards, bgCards, duelsCards,
  defaultHeroSounds, deathKnightHeroSounds, deathKnightRexxarHeroSounds, sharedCustomHeroSounds, galakrondHeroSounds, ragAndLordJarraxxusHeroSounds, medivhHeroSounds, renoHeroSounds, heroCardCustomSounds,
  customCthun, customAluneth, customSkulloftheManari, customBarnes, customVulgarHomunculus, customHecklebot, customEvilHeclkerDalaranCrusader, customYogg, customFortuneTeller, customCheesemonger, customElitistSnob, customHipster, transferStudentTokens,
  altSoundsID, complicatedAltSound, nonCoreCardVersions, getCardSounds, buildHeroSoundArray
}
